import { defineMessages } from 'react-intl';

export default defineMessages({
    account: {
        id: 'header.links.Account',
        defaultMessage: 'Account'
    },
    faq: {
        id: 'header.links.FAQ',
        defaultMessage: 'FAQ'
    },
    logout: {
        id: 'header.links.Logout',
        defaultMessage: 'Logout'
    },
    myClaims: {
        id: 'header.links.myClaims',
        defaultMessage: 'My Claims'
    },
    myBillings: {
        id: 'header.links.myBillings',
        defaultMessage: 'My Billing'
    },
    home: {
        id: 'header.links.home',
        defaultMessage: 'Home'
    },
    policyDocuments: {
        id: 'header.links.policyDocuments',
        defaultMessage: 'Policy Documents'
    },
    makeAClaim: {
        id: 'header.links.makeAClaim',
        defaultMessage: 'Make a Claim'
    },
    copyrightMesssage: {
        id: 'footer.copyrightMesssage',
        defaultMessage: '© 2021 Ayr Farmers Mutual Insurance Company. All rights reserved.'
    },
    termsAndConditions: {
        id: 'footer.termsAndConditions',
        defaultMessage: 'Terms & Conditions'
    },
    privacyPolicy: {
        id: 'footer.privacyPolicy',
        defaultMessage: 'Privacy Policy'
    },
    complaintHandling: {
        id: 'footer.complaintHandling',
        defaultMessage: 'Complaint Handling Protocol'
    },
    makeAClaim: {
        id: "gateway.views.new-quote.Make a Claim",
        defaultMessage: "Make a Claim"
    },
    ayrCopyrightMesssage: {
        id: 'footer.ayrcopyrightMesssage',
        defaultMessage: '© {year} Ayr Farmers Mutual Insurance Company. All rights reserved.'
    },
    navClaim: {
        id: 'header.links.navClaim',
        defaultMessage: 'Claims'
    },
    navBilling: {
        id: 'header.links.navBilling',
        defaultMessage: 'Billing'
    },
    makePayment: {
        id: "gateway.views.new-quote.Make a Payment",
        defaultMessage: "Make a Payment"
      }
});
